import { LoadingIndicator } from "@/components/ui/loading-indicator";
import useMusioApi from "@/contexts/client/musio-client-context";
import { SubscriptionInformationCard } from "./musio-plus/subscription-information-card";
import { PastDueCard } from "./musio-plus/past-due-card";
import { SubscribeCard } from "./musio-plus/subscribe-card";
import { ReactComponent as MusioLogoBlue } from "@/assets/musio-logos/musio-logo-blue.svg";
import { Helmet } from "@dr.pogodin/react-helmet";
import { CancelledCard } from "./musio-plus/cancelled-card";
import type { RecurringStatus } from "@/types/api";
import { PausedCard } from "./musio-plus/paused-card";
import BillingInfoCard from "./musio-plus/billing-card";

export enum RecurringStatusState {
  Active = "active",
  PastDue = "past_due",
  Paused = "paused",
  Trialing = "trialing",
  Inactive = "inactive",
}

export enum RecurringPlanState {
  Monthly = "monthly",
  Annual = "Annual",
}

export type SubscriptionInformationCardProps = {
  recurringStatus: RecurringStatus;
}

// TODO: add error to this page
export const MusioPlus = () => {
  const { musioApi } = useMusioApi();
  const { data, isPending } = musioApi.useQuery("get", "/user/recurring");

  if (isPending) {
    return (
      <div className="fixed grid place-items-center h-full w-full">
        <LoadingIndicator />
      </div>
    );
  }

  const renderCard = () => {
    switch (data!.status) {
      case "active":
      case "trialing":
        if (data?.canceled) {
          return <CancelledCard recurringStatus={data!} />
        } else {
          return <SubscriptionInformationCard recurringStatus={data!} />
        }
      // TODO: uncomment this and import when service updates with information
      case "paused":
        return <PausedCard recurringStatus={data!} />
      case "past_due":
        return <PastDueCard />
    }

    return <SubscribeCard />
  }

  return (
    <>
      <Helmet>
        <title>Manage Your Musio+ Subscription</title>
        <meta name="description" content="Subscribe to Musio+" />
      </Helmet>
      <div className="px-7 py-2 w-full">

        <div className="py-7">
          <div className="h-[26px]">
            <MusioLogoBlue className="h-full" />
          </div>
        </div>

        <div className="w-full py-1 flex flex-col items-center sm:items-baseline sm:flex-row gap-5 space-x-5">
          <div className="flex-1 space-y-3">
            <div>
              <h3 className="text-xl font-semibold py-1 text-musio-light-lilac">Musio+</h3>
              <p className="text-sm text-musio-light-lilac">
                Unlocks unlimited access to an extensive and expanding selection of instruments, refreshed with new additions on a regular basis.
              </p>
            </div>
            <h4 className="text-xs light py-1 text-musio-light-lilac">Are you a student? - <a className="text-musio-green underline" href="https://musio.com/edu" target="_blank">See EDU offers</a></h4>
          </div>

          <div className="flex flex-col gap-1">
            {renderCard()}

            <BillingInfoCard />
          </div>


        </div>
      </div>
    </>
  );
};
